
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.371","height":"17.396"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_21390","data-name":"Group 21390","transform":"translate(-991.256 -619.73)"}},[_c('path',{attrs:{"id":"Path_1","data-name":"Path 1","d":"M1008.627 630.39a1.918 1.918 0 01-1.915 1.915h-1.546v3.613a1.207 1.207 0 01-1.208 1.208h-3.831v-1.571a1.917 1.917 0 00-3.834 0v1.571h-3.833a1.206 1.206 0 01-1.2-1.208v-3.613h1.381a1.915 1.915 0 000-3.831h-1.381v-4.051a1.206 1.206 0 011.2-1.208h3.834v-1.571a1.917 1.917 0 013.834 0v1.571h3.831a1.207 1.207 0 011.208 1.208v4.051h1.546a1.914 1.914 0 011.914 1.916z","fill":"#66717d"}})])])
          )
        }
      }
    